<template>
  <div class='cm-preview-card'>
    <CompanyCard :company='company' />
  </div>
</template>

<script>
import CompanyCard from '../components/company-card.vue';

export default {
  components: {
    CompanyCard,
  },

  data () {
    return {
      company: {
        name: "Carolyn Sewell",
        location: "Raleigh, NC",
        motto: "Lettering and Illustration Deep-Fried in Butter and Hugs.",
        banner: "https://media.creativemornings.com/uploads/sponsor/banner/5970/large_OverlapTanglesWallMockup_2560x900.jpg",
        logo: "https://media.creativemornings.com/uploads/sponsor/logo/5970/square_Carolyn_Sewell_LogoSquare.png"
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// app/javascript/onboarding/preview-card.vue?047f9e7f